import { CHECKOUT_URL } from "@/lib/site";

const LINKS = [
  ["How it works", "#how-it-works"],
  ["Workouts", "#workouts"],
  ["Features", "#features"],
  ["Results", "#results"],
  ["Pricing", "#pricing"],
  ["FAQ", "#faq"],
];

export const Header = () => (
  <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/60 shadow-sm">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 md:h-20 flex items-center justify-between">
      <a data-testid="header-logo" href="#top" className="flex items-center gap-2 font-display font-extrabold text-lg md:text-xl text-white">
        <img src="/assets/logo.png" alt="Bryan Lee Fitness logo" className="w-9 h-9 rounded-lg" />
        <span className="hidden min-[420px]:inline whitespace-nowrap">Bryan Lee <span className="text-blue-400">Fitness</span></span>
      </a>
      <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation">
        {LINKS.map(([label, href]) => (
          <a key={href} data-testid={`nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`} href={href} className="text-sm font-semibold text-slate-400 hover:text-white transition-colors">
            {label}
          </a>
        ))}
      </nav>
      <a data-testid="header-cta-button" href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center justify-center rounded-full bg-blue-600 text-white px-4 py-2 sm:px-5 sm:py-2.5 md:px-7 md:py-3 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap transition-[transform,box-shadow] duration-300 shadow-[0_8px_20px_0_rgb(37,99,235,0.3)] hover:shadow-[0_12px_25px_0_rgb(37,99,235,0.4)] hover:-translate-y-0.5 active:translate-y-0 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:outline-none focus-visible:ring-offset-2">
        Start Free Trial
      </a>
    </div>
  </header>
);
